// Tab-scoped (sessionStorage) flags coordinating the automatic Microsoft handoff
// in AppComponent. They must survive the full-page redirect to Microsoft, but not
// leak into other tabs or later browser sessions.

/** Set before redirecting with `prompt: 'none'`, so the handoff runs once per tab. */
export const SILENT_REDIRECT_FLAG = 'msal_silent_redirect_attempted';

/** Set on explicit sign-out, so the user is not signed straight back in. */
export const LOGOUT_FLAG = 'msal_user_signed_out';
